export const mergeChatMessages = (current, incoming) => {
  const messages = new Map(current.filter(item => item.id).map(item => [item.id, item]))
  for (const item of incoming) if (item.id) messages.set(item.id, item)
  return [...messages.values()].sort((a, b) => a.sequence - b.sequence)
}

export const chatRequestKey = () => {
  if (globalThis.crypto?.randomUUID) return crypto.randomUUID()
  const bytes = crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const hex = [...bytes].map(byte => byte.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

export const chatSocketUrl = (baseURL, origin) => {
  const url = new URL(baseURL || '/', origin)
  if (!['http:', 'https:'].includes(url.protocol)) throw new Error('Invalid API URL')
  url.pathname = `${url.pathname.replace(/\/$/, '')}/api/v1/chat/ws`
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
  url.search = ''
  url.hash = ''
  return url.toString()
}

const chatDateFormatter = new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: 'long', day: 'numeric' })
const chatTimeFormatter = new Intl.DateTimeFormat('fa-IR', { hour: '2-digit', minute: '2-digit' })
const formatChatTimestamp = (value, formatter) => {
  if (!value) return ''
  const date = new Date(value)
  return Number.isFinite(date.getTime()) ? formatter.format(date) : ''
}
export const formatChatDate = value => formatChatTimestamp(value, chatDateFormatter)
export const formatChatTime = value => formatChatTimestamp(value, chatTimeFormatter)
const normalizeChatSearch = value => String(value ?? '').replace(/ي/g, 'ی').replace(/ك/g, 'ک')
  .replace(/[\u064B-\u065F\u0670]/g, '').trim().toLocaleLowerCase()
export const filterChatConversations = (items, query, asCompany = false) => {
  const search = normalizeChatSearch(query)
  if (!search) return items
  return items.filter(item => normalizeChatSearch(`${(asCompany ? item.customerName : item.companyName) || ''} ${item.preview || ''}`).includes(search))
}
